// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
    margin: 12px;
}

/* One centered column under the header, like the Busy Bees page. Paired
   with .container so it beats the global .container max-width. */
.container.intake-layout {
  max-width: 640px;
  margin: 0 auto 24px;
}

.intake-section {
  padding-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Intake.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;iEACiE;AACjE;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".btn {\n    margin: 12px;\n}\n\n/* One centered column under the header, like the Busy Bees page. Paired\n   with .container so it beats the global .container max-width. */\n.container.intake-layout {\n  max-width: 640px;\n  margin: 0 auto 24px;\n}\n\n.intake-section {\n  padding-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
